import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {trimInput} from "@myshared/utils";

@Component({
    selector: 'app-phonenumber-bill-company-name',
    templateUrl: 'phonenumber-bill-company-name.component.html',
    standalone: false
})
export class PhonenumberBillCompanyNameComponent implements OnInit {

  @Input() companyName: string;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      companyName: [this.companyName || '', Validators.required]
    });
  }

  public onNext() {
    if (this.form.invalid) return;
    const input = trimInput(this.form.get('companyName').value)
    this.selected.emit(input);
  }

  get formControl() {
    return this.form.get('companyName') as UntypedFormControl;
  }

}
